<template>
  <div>
    <ConfirmModal
        ref="modalAvisoAlteracaoDuam"
        title="Alterar DUAM"
        description="Confirma a alteração da DUAM?"
        @confirm="realizarAlteracaoDUAM"
        @cancel="closeModalAlteracaoDuam"
    />
    <ConfirmModal
        ref="modalAvisoBaixaManual"
        title="Baixa Manual"
        description="Confirma a baixa manual da DUAM?"
        @confirm="baixaManual"
        @cancel="hideModalBaixaManualConfirmacao"
    />
    <Layout>
      <PageHeader :title="title" :items="items"/>
      <Aguarde :show="httpSend"></Aguarde>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="mt-1 mb-3">Lista de DUAMs Emitidas</h5>
              <div class="row">
                <div class="col-12">
                  <b-form @submit.prevent="alteraListaDuam()">
                    <div class="row">
                      <div class="col-md-4">
                        <b-form-group
                            label="Nome/Razão Social"
                            label-for="pes_nome">
                          <input
                              id="pes_nome"
                              v-model="filtro.pes_nome"
                              type="text"
                              maxlength="200"
                              class="form-control"
                              placeholder=" ">
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                            label="Nome Fantasia"
                            label-for="eco_nome_fantasia">
                          <input
                              id="eco_nome_fantasia"
                              v-model="filtro.eco_nome_fantasia"
                              type="text"
                              maxlength="200"
                              class="form-control"
                              placeholder=" ">
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                            label="CPF/CNPJ">
                          <the-mask class="form-control" v-model="filtro.pes_cpfcnpj"
                                    :mask="['###.###.###-##', '##.###.###/####-##']"/>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                     <div class="col-md-4">
               <b-form-group label="Competência Inicial" label-for="sep_competencia_inicial" class="mb-2">
                 <input id="sep_competencia_inicial" v-model="filtro.sep_competencia_inicial" v-mask="'##/####'" type="text" maxlength="7" class="form-control" placeholder="Mês/Ano">
               </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group label="Competência Final" label-for="sep_competencia_final" class="mb-2">
                 <input id="sep_competencia_final" v-model="filtro.sep_competencia_final" v-mask="'##/####'" type="text" maxlength="7" class="form-control" placeholder="Mês/Ano">
               </b-form-group>
            </div>
                      <div class="col-md-4">
                        <b-form-group
                            label="Código da DUAM"
                            label-for="dam_codigo">
                          <input
                              id="dam_codigo"
                              v-model="filtro.dam_codigo"
                              type="text"
                              maxlength="20"
                              class="form-control"
                              placeholder=" ">
                        </b-form-group>
                      </div>
                      <div class="col-md-8">
                        <b-form-group label="Status da DUAM" label-for="tab_106situacao">
                          <select id="tab_106situacao"
                                  v-model="filtro.tab_106situacao"
                                  @change="alteraListaDuam()"
                                  class="custom-select" type="text">
                            <option value="">Todas DUAMs</option>
                            <option value="963">Em Aberto</option>
                            <option value="964">Aguardando pagamento - sob demanda</option>
                            <option value="965">Inscrita Divida Ativa</option>
                            <option value="966">Parcelada</option>
                            <option value="967">Estorno para Repactuação</option>
                            <option value="968">Suspensão Ato Administrativo</option>
                            <option value="969">Suspensão Decisão Judicial</option>
                            <option value="970">Cancelado</option>
                            <option value="971">Prescrita</option>
                            <option value="972">Estimativa Simples Nacional</option>
                            <option value="973">Isento</option>
                            <option value="974">Imune</option>
                            <option value="975">Pagamento Parcial</option>
                            <option value="976">Pagamento Total</option>
                          </select>
                        </b-form-group>
                      </div>
                      <div class="col-md-2 text-right">
                        <b-form-group
                            label="'"
                            class="text-white">
                          <button type="submit"
                                  class="btn btn-label btn-primary"><i
                              class="bx bx-search label-icon"></i>
                            Pesquisar
                          </button>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
          <div>
            <DuamList
                :pagina-atual="filtro.pagina"
                :total-paginas="total_paginas"
                :resumo="resumo"
                :guias="list_duam"
                :por-pagina="40"
                @mudarPagina="proximaPagina"
                @pagamento="pagamento"
                @baixa-manual="showModalbaixaManual"
                @alterar-duam="openModalAlteracaoDuam"
                @print-comprovante="printComprovante"
                @guia-detalhe="guiaDetalhe"
            />
          </div>
        </div>
      </div>
      <b-modal
          id="modal-alterar-duam"
          ref="modal-alterar-duam"
          title="Alteração de DUAN"
          title-class="font-18"
          size="xl"
          :hide-header-close="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          @hidden="closeModalAlteracaoDuam">
        <div class="modal-body pb-0">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="N° da DUAM">
                    <h6 class="mb-0">{{ edit_duam.dam_codigo }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Competência">
                    <h6 class="mb-0">{{ edit_duam.dam_mes_ref }}/{{ edit_duam.dam_ano_ref }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Vencimento Original">
                    <h5 class="mb-0 text-danger">
                      {{ edit_duam.dam_data_venc_orig | formatDate }}</h5>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div v-if="edit_duam.pes_cpfcnpj" class="col-md-4">
                  <b-form-group label="CPF/CNPJ">
                    <h6 v-if="edit_duam.pes_cpfcnpj.length < 12" class="mb-0">
                      {{ edit_duam.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
                    <h6 v-else class="mb-0">{{ edit_duam.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <b-form-group label="Nome/Razão Social">
                    <h6 class="mb-0">{{ edit_duam.pes_nome }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Valor Total">
                    <h6 class="mb-0">{{ edit_duam.dut_valortotal | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <b-form-group label="Tipo de DUAM">
                    <h6 class="mb-0">{{ edit_duam.tab_nome }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <b-form-group
                      label="Novo Vencimento Original"
                      label-for="novo_vencimento_original">
                    <input id="novo_vencimento_original" v-model="novo_vencimento_original" type="date"
                           class="form-control">
                    <div class="text-muted">Alterar multa e juros</div>
                  </b-form-group>
                </div>
                <div class="col-sm-8">
                  <b-form-group label="Novo Tipo" label-for="new_106situacao">
                    <select id="new_106situacao" class="custom-select" v-model="new_106situacao" type="text">
                      <option value="963">ABERTA</option>
                      <option value="968">SUSPENSÃO ATO ADMINISTRATIVO</option>
                      <option value="969">SUSPENSÃO DECISÃO JUDICIAL</option>
                      <option value="970">CANCELADO</option>
                      <option value="972">ESTIMATIVA SIMPLES NACIONAL</option>
                      <option value="973">ISENTO</option>
                      <option value="974">IMUNE</option>
                    </select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <b-form-group label="Motivo" label-for="novo_vencimento">
                  <textarea class="form-control" placeholder="Informe o motivo da alteração" :maxlength="250"
                            v-model="motivo_alteracao" rows="3">
                  </textarea>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #modal-footer="{cancel}">
          <b-button @click="showModalAlteracaoDuamConfirmacao" class="btn btn-success">
            <i class="bx bx-check-double"></i> Realizar Alteração
          </b-button>
          <b-button @click="closeModalAlteracaoDuam" variant="outline-dark">
            Fechar
          </b-button>
        </template>
      </b-modal>
      <b-modal
          id="modal-baixa-manual"
          ref="modal-baixa-manual"
          title="Alteração de DUAN"
          title-class="font-18"
          size="xl"
          :hide-header-close="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          @hidden="hideModalBaixaManual">
        <div class="modal-body pb-0">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="N° da DUAM">
                    <h6 class="mb-0">{{ duam_baixa_manual.dam_codigo }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Competência">
                    <h6 class="mb-0">{{ duam_baixa_manual.dam_mes_ref }}/{{ duam_baixa_manual.dam_ano_ref }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Vencimento">
                    <h5 class="mb-0 text-danger">
                      {{ duam_baixa_manual.dam_data_venc_atu | formatDate }}</h5>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div v-if="duam_baixa_manual.pes_cpfcnpj" class="col-md-4">
                  <b-form-group label="CPF/CNPJ">
                    <h6 v-if="duam_baixa_manual.pes_cpfcnpj.length < 12" class="mb-0">
                      {{ duam_baixa_manual.pes_cpfcnpj | VMask('###.###.###-##') }}</h6>
                    <h6 v-else class="mb-0">{{ duam_baixa_manual.pes_cpfcnpj | VMask('##.###.###/####-##') }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-8">
                  <b-form-group label="Nome/Razão Social">
                    <h6 class="mb-0">{{ duam_baixa_manual.pes_nome }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Valor">
                    <h6 class="mb-0">{{ duam_baixa_manual.dut_valortributo | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Juros">
                    <h6 class="mb-0">{{ duam_baixa_manual.dut_juros | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Multa">
                    <h6 class="mb-0">{{ duam_baixa_manual.dut_multa | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Atualizações">
                    <h6 class="mb-0">{{ duam_baixa_manual.dut_atualizacao | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Desconto">
                    <h6 class="mb-0">{{ duam_baixa_manual.dut_desconto | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Total">
                    <h5 class="mb-0 text-danger">{{ duam_baixa_manual.dut_valortotal | formatNumeroBr }}</h5>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                      label="Data do Crédito"
                      label-for="bab_data_credbanco">
                    <input
                        id="bab_data_credbanco"
                        v-model="duam_baixa_manual.bab_data_credbanco"
                        type="date"
                        class="form-control">
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                      label="Valor Pago"
                      label-for="bab_valor_pago">
                    <money class="form-control"
                           id="bab_valor_pago"
                           v-model="duam_baixa_manual.bab_valor_pago"
                           v-bind="money"></money>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #modal-footer="{cancel}">
          <b-button @click="showModalbaixaManualConfirmacao" class="btn btn-success">
            <i class="bx bx-check-double"></i> Realizar Baixa
          </b-button>
          <b-button @click="hideModalBaixaManual" variant="outline-dark">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </Layout>
  </div>

</template>
<script>
import Layout from "@/router/layouts/main";
import {VMoney, Money} from 'v-money'
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde";
import {TheMask} from 'vue-the-mask'
import {duamAlterar, duamBaixaManual, listDuamsEmitidas} from "@/api/admin/gestao/duams_emitidas";
import {impressao} from "@/helps/impressao";
import {getFinanceiroComprovante, getFinanceiroGuia} from "@/api/relatorio/financeiro";
import {notifyAviso, notifyErro, notifySucesso} from "@/helps/notificacao";
import DuamList from "@/router/views/admin/components/gestao/DuamList.vue";
import ConfirmModal from "@/components/widgets/ConfirmModal.vue";

//falta criar a tabela e API

export default {
  page: {
    title: "Guias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    ConfirmModal,
    DuamList,
    Layout,
    Money,
    PageHeader,
    TheMask,
    Aguarde
  },
  directives: {money: VMoney},
  data() {
    return {
      title: "DUAMs Emitidas",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAMs Emitidas',
          active: true,
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      httpSend: false,
      httpSenVerifica: false,
      avisoBaixaManual: false,
      filtro: {
        pagina: 1,
        dam_codigo: "",
        pes_nome: "",
        eco_nome_fantasia: "",
        pes_cpfcnpj: "",
        tab_106situacao: "963",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
      },
      total_paginas: 0,
      resumo: {},
      list_duam: [],
      duam_baixa_manual: {},
      edit_duam: {},
      new_106situacao: "",
      novo_vencimento_original: "",
      motivo_alteracao: "",
      duam_atualizada: {
        dam_codigo: null
      },
    };
  },
  computed: {
    tipo_arrecadacao: {
      get: function () {
        return parseInt(this.$store.state.auth.currentEntidade.par_tipo_cobranca);
      },
    },
  },
  created() {
    this.listDuams();
  },
  methods: {
    alteraListaDuam(){
      this.filtro.pagina = 1;
      this.listDuams();
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.listDuams()
    },
    listDuams() {
      this.httpSend = true;
      listDuamsEmitidas(this.filtro).then(result => {
        this.total_paginas = result.dados.paginas;
        this.resumo = result.dados.resumo
        this.list_duam = [...result.dados.guias];
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    guiaDetalhe(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-guia-detalhe",
        params: {dam_hash: guia.dam_hash}
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
    openModalAlteracaoDuam(duam) {
      this.edit_duam = duam;
      this.$refs['modal-alterar-duam'].show();
    },
    closeModalAlteracaoDuam() {
      this.$refs['modal-alterar-duam'].hide();
      this.edit_duam = {};
      this.motivo_alteracao = '';
      this.new_106situacao = '';
    },
    showModalbaixaManualConfirmacao() {
      if (!this.duam_baixa_manual.bab_data_credbanco) {
        notifyAviso("Atenção", "Verifique a Data do Crédito")
        return
      }
      if (this.duam_baixa_manual.bab_valor_pago <= 0) {
        notifyAviso("Atenção", "Valor pago deve ser maior que zero")
        return
      }
      this.$refs.modalAvisoBaixaManual.show()
    },
    showModalbaixaManual(duam) {
      this.duam_baixa_manual = duam;
      this.$refs['modal-baixa-manual'].show();
    },
    hideModalBaixaManual() {
      this.$refs['modal-baixa-manual'].hide();
      this.duam_baixa_manual = {};
    },
    hideModalBaixaManualConfirmacao() {
      this.$modal.hide('modal-baixa-manual-confirmacao');
    },
    showModalAlteracaoDuamConfirmacao() {
      if (this.new_106situacao === '' && this.novo_vencimento_original === '') {
        notifyAviso("Atenção", "Selecione um novo Tipo ou informe um novo vencimento original")
        return
      }
      if (this.motivo_alteracao.length < 3) {
        notifyAviso("Atenção", "Informe um motivo")
        return
      }
      this.$refs.modalAvisoAlteracaoDuam.show()
    },
    realizarAlteracaoDUAM() {
      const dados = {
        dam_codigo: this.edit_duam.dam_codigo,
        novo_vencimento_original: this.novo_vencimento_original,
        new_106situacao: this.new_106situacao,
        motivo_alteracao: this.motivo_alteracao,
      }
      this.httpSend = true;
      duamAlterar(dados).then(result => {
        if (result.status) {
          this.listDuams();
          notifySucesso("DattaNFSe", result.mensagem)
          this.closeModalAlteracaoDuam();
        } else {
          notifyErro("Erro ao Alterar Duam", result.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    baixaManual() {
      this.httpSend = true;
      duamBaixaManual(this.duam_baixa_manual).then(result => {
        if (result.status) {
          this.listDuams();
          notifySucesso("DattaNFSe", result.mensagem)
          this.hideModalBaixaManualConfirmacao();
          this.hideModalBaixaManual();
        } else {
          notifyErro("Erro ao Baixar Duam", result.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    printGuia(guia) {
      this.httpSend = true;
      impressao(getFinanceiroGuia(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    printComprovante(guia) {
      this.httpSend = true;
      impressao(getFinanceiroComprovante(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>


